var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({staticClass:"tw-bg-[#0A8EFF] tw-text-white tw-font-lato tw-font-black tw-text-[18px] tw-px-[27px] tw-py-[14px] tw-rounded-full"},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }